import PropTypes from 'prop-types';

const suggestionsPropType = PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
}));

export default suggestionsPropType;
